import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Box, Container, Typography, Button, Grid } from '@mui/material';
import { Speed, VerifiedUser, TrendingUp } from '@mui/icons-material';
import { servicesColors as colors } from '../theme';
const ctaStats = [
    { icon: Speed, value: '10sec', label: 'Average screening time' },
    { icon: VerifiedUser, value: '100%', label: 'Certification extraction' },
    { icon: TrendingUp, value: '3x', label: 'More qualified callbacks' },
];
export const CtaSection = () => {
    return (_jsxs(Box, { component: "section", sx: {
            py: { xs: 8, md: 12 },
            background: colors.gradient,
            position: 'relative',
            overflow: 'hidden',
        }, children: [_jsx(Box, { sx: {
                    position: 'absolute',
                    top: -100,
                    right: -100,
                    width: 400,
                    height: 400,
                    borderRadius: '50%',
                    background: 'rgba(255, 255, 255, 0.05)',
                } }), _jsx(Box, { sx: {
                    position: 'absolute',
                    bottom: -150,
                    left: -150,
                    width: 500,
                    height: 500,
                    borderRadius: '50%',
                    background: 'rgba(255, 255, 255, 0.03)',
                } }), _jsxs(Container, { maxWidth: "lg", sx: { position: 'relative', zIndex: 1 }, children: [_jsxs(Box, { sx: { textAlign: 'center', mb: 6 }, children: [_jsx(Typography, { variant: "h2", sx: {
                                    fontWeight: 700,
                                    color: '#ffffff',
                                    fontSize: { xs: '2rem', md: '2.75rem' },
                                    mb: 2
                                }, children: "Stop Losing Great Techs to Slow Hiring" }), _jsx(Typography, { sx: {
                                    color: 'rgba(255, 255, 255, 0.85)',
                                    fontSize: '1.15rem',
                                    maxWidth: 650,
                                    mx: 'auto',
                                    lineHeight: 1.7
                                }, children: "Skilled tradespeople don't stay on the market long. Screen smarter, respond faster, and hire the certified professionals your business needs." })] }), _jsx(Grid, { container: true, spacing: 3, sx: { mb: 6 }, children: ctaStats.map((stat, index) => (_jsx(Grid, { size: { xs: 12, sm: 4 }, children: _jsxs(Box, { sx: {
                                    textAlign: 'center',
                                    p: 3,
                                    backgroundColor: 'rgba(255, 255, 255, 0.1)',
                                    borderRadius: 3,
                                    backdropFilter: 'blur(10px)',
                                }, children: [_jsx(stat.icon, { sx: { fontSize: 40, color: colors.secondary, mb: 1 } }), _jsx(Typography, { sx: {
                                            fontWeight: 800,
                                            fontSize: '2rem',
                                            color: '#ffffff',
                                            mb: 0.5
                                        }, children: stat.value }), _jsx(Typography, { sx: {
                                            color: 'rgba(255, 255, 255, 0.75)',
                                            fontSize: '0.9rem'
                                        }, children: stat.label })] }) }, index))) }), _jsxs(Box, { sx: {
                            display: 'flex',
                            flexDirection: { xs: 'column', sm: 'row' },
                            justifyContent: 'center',
                            alignItems: 'center',
                            gap: 2
                        }, children: [_jsx(Button, { variant: "contained", size: "large", href: "/onboarding?industry=services", sx: {
                                    py: 2,
                                    px: 5,
                                    fontSize: '1.1rem',
                                    fontWeight: 600,
                                    backgroundColor: '#ffffff',
                                    color: colors.primary,
                                    '&:hover': {
                                        backgroundColor: 'rgba(255, 255, 255, 0.9)',
                                        transform: 'translateY(-2px)',
                                    },
                                }, children: "Score a resume in 30s \u2192" }), _jsx(Typography, { sx: {
                                    color: 'rgba(255, 255, 255, 0.7)',
                                    fontSize: '0.9rem'
                                }, children: "No credit card required \u2022 50 free resume analyses" })] }), _jsx(Box, { sx: {
                            mt: 6,
                            p: 3,
                            backgroundColor: 'rgba(249, 115, 22, 0.2)',
                            borderRadius: 3,
                            border: '1px solid rgba(249, 115, 22, 0.4)',
                            textAlign: 'center',
                        }, children: _jsxs(Typography, { sx: {
                                color: '#ffffff',
                                fontWeight: 600,
                                fontSize: '1rem',
                            }, children: ["\uD83D\uDD25 Peak hiring season is here. Service businesses using StanorAI fill positions", ' ', _jsx(Box, { component: "span", sx: { color: colors.secondary }, children: "67% faster" }), ' ', "than industry average."] }) })] })] }));
};
